(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  // Close topbar dropdown when clicking outside (and on Escape).
  const topbarDropdowns = Array.from(document.querySelectorAll('.topbar-links-dropdown'));
  if (topbarDropdowns.length) {
    document.addEventListener('click', (event) => {
      topbarDropdowns.forEach((dropdown) => {
        if (!dropdown.hasAttribute('open')) return;
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      topbarDropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
    });

    // If multiple dropdowns exist, keep only one open.
    topbarDropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        topbarDropdowns.forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
